<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="shadow border-b border-gray-200  bg-white sm:rounded-lg">
    <div class="w-3/4 m-10 z-10">
      <h1 class="text-2xl font-bold text-gray-900 truncate pt-10 mb-10">
        Select Dropdowns
      </h1>
      <h2 class="text-xl font-bold text-gray-900 truncate pt-10 mb-10">
        Language Pickers
      </h2>
      <div class="space-y-6 sm:space-y-5">
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <LanguageSelectPicker
            v-model="form.language"
            label="Language Selector - Initial null"
          />
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            Language: {{ form.language ? form.language.id : '' }}
          </div>
        </div>

        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <LanguageSelectPicker
            v-model="form.language_pre"
            label="Language Selector - Pre-filled"
          />
          <div class="mt-1 sm:mt-0 sm:col-span-2">
            Language: {{ form.language_pre ? form.language_pre.id : '' }}
          </div>
        </div>
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <LanguageSelectPickerMultiple
            v-model="form.multi_language"
            label="Languages Selector (Multiple) - Initial null"
          />
        </div>

        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
          <LanguageSelectPickerMultiple
            v-model="form.multi_language_pre"
            label="Language Selector (Multiple) - Pre-filled"
          />
        </div>

        <h2 class="text-xl font-bold text-gray-900 truncate pt-10 mb-10">
          Destination Pickers
        </h2>
        <div class="space-y-6 sm:space-y-5">
          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <DestinationSelectPicker
              v-model="form.destination"
              label="Destination Selector - Initial null"
            />
            <div class="mt-1 sm:mt-0 sm:col-span-2">
              Destination: {{ form.destination ? form.destination.id : '' }}
            </div>
          </div>

          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <DestinationSelectPicker
              v-model="form.destination_pre"
              label="Destination Selector - Pre-filled"
            />
            <div class="mt-1 sm:mt-0 sm:col-span-2">
              Destination: {{ form.destination_pre ? form.destination_pre.id : '' }}
            </div>
          </div>
          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <DestinationSelectPickerMultiple
              v-model="form.multi_destination"
              label="Destination Selector (Multiple) - Initial null"
            />
          </div>

          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <DestinationSelectPickerMultiple
              v-model="form.multi_destination_pre"
              label="Destination Selector (Multiple) - Pre-filled"
            />
          </div>
        </div>
        <h2 class="text-xl font-bold text-gray-900 truncate pt-10 mb-10">
          Currency Pickers
        </h2>
        <div class="space-y-6 sm:space-y-5">
          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <CurrencySelectPicker
              v-model="form.currency"
              label="Currency Selector - Initial null"
            />
            <div class="mt-1 sm:mt-0 sm:col-span-2">
              Currency: {{ form.currency ? form.currency.id : '' }}
            </div>
          </div>

          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <CurrencySelectPicker
              v-model="form.currency_pre"
              label="Currency Selector - Pre-filled"
            />
            <div class="mt-1 sm:mt-0 sm:col-span-2">
              Currency: {{ form.currency_pre ? form.currency_pre.id : '' }}
            </div>
          </div>
          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <CurrencySelectPickerMultiple
              v-model="form.multi_currency"
              label="Currency Selector (Multiple) - Initial null"
            />
          </div>

          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <CurrencySelectPickerMultiple
              v-model="form.multi_currency_pre"
              label="Currency Selector (Multiple) - Pre-filled"
            />
          </div>
        </div>
        <h2 class="text-xl font-bold text-gray-900 truncate pt-10 mb-10">
          Guide Pickers
        </h2>
        <div class="space-y-6 sm:space-y-5">
          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <GuideSelectPicker
              v-model="form.guide"
              label="Guide Selector - Initial null"
            />
            <div class="mt-1 sm:mt-0 sm:col-span-2">
              Guide: {{ form.guide ? form.guide.id : '' }}
            </div>
          </div>

          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <GuideSelectPicker
              v-model="form.guide_pre"
              label="Guide Selector - Pre-filled"
            />
            <div class="mt-1 sm:mt-0 sm:col-span-2">
              Guide: {{ form.guide_pre ? form.guide_pre.id : '' }}
            </div>
          </div>
          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <GuideSelectPickerMultiple
              v-model="form.multi_guide"
              label="Guide Selector (Multiple) - Initial null"
            />
          </div>

          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <GuideSelectPickerMultiple
              v-model="form.multi_guide_pre"
              label="Guide Selector (Multiple) - Pre-filled"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SelectPicker from '../ComponentsDeprecated/Select/SelectPicker.vue';
import SelectPickerMultiple from '../ComponentsDeprecated/Select/SelectPickerMultiple.vue';
import LanguageSelectPicker from '../ComponentsDeprecated/Select/LanguageSelectPicker';
import LanguageSelectPickerMultiple from '@/ComponentsDeprecated/Select/LanguageSelectPickerMultiple';
import DestinationSelectPicker from '@/ComponentsDeprecated/Select/DestinationSelectPicker';
import DestinationSelectPickerMultiple from '@/ComponentsDeprecated/Select/DestinationSelectPickerMultiple';
import CurrencySelectPicker from '@/ComponentsDeprecated/Select/CurrencySelectPicker';
import CurrencySelectPickerMultiple from '@/ComponentsDeprecated/Select/CurrencySelectPickerMultiple';
import GuideSelectPicker from '@/ComponentsDeprecated/Select/GuideSelectPicker';
import GuideSelectPickerMultiple from '@/ComponentsDeprecated/Select/GuideSelectPickerMultiple';

export default {
  components: {
    GuideSelectPickerMultiple,
    GuideSelectPicker,
    CurrencySelectPickerMultiple,
    CurrencySelectPicker,
    LanguageSelectPickerMultiple,
    SelectPicker,
    SelectPickerMultiple,
    LanguageSelectPicker,
    DestinationSelectPicker,
    DestinationSelectPickerMultiple,
  },
  props: {

  },
  data() {
    return {
      form: this.$inertia.form({
        language: null,
        language_pre: {
          id: 'nb',
          name: 'Norwegian bokmål',
          flag: '/flags/NO.svg',
          image: '/img/flags/NO.svg',
          native: 'Norsk Bokmål',
        },
        multi_language: [],
        multi_language_pre: [
          {
            id: 'nb',
            name: 'Norwegian bokmål',
            flag: '/flags/NO.svg',
            image: '/img/flags/NO.svg',
            native: 'Norsk Bokmål',
          },
          {
            id: 'nn',
            name: 'Norwegian nynorsk',
            flag: '/flags/NO.svg',
            image: '/img/flags/NO.svg',
            native: 'Norsk Nynorsk',
          },
        ],

        destination: null,
        destination_pre: {
          id: 254,
          name: 'Barcelona',
          area: 'Catalonia, Spain',
          place_id: 'ChIJ5TCOcRaYpBIRCmZHTz37sEQ',
          slug: 'barcelona-catalonia-spain',
          parent_id: 73,
          type: 'destination',
          img: null,
          location: {
            type: 'Point',
            coordinates: [41.3873974, 2.168568],
          },
          viewport_north_east: {
            type: 'Point',
            coordinates: [41.468297427243, 2.2280449242179],
          },
          viewport_south_west: {
            type: 'Point', coordinates: [41.317038489254, 2.0523332629526],
          },
          created_at: '2022-03-29T08:37:26.000000Z',
          updated_at: '2022-03-29T08:37:26.000000Z',
          database: true,
          image: '\/img\/flags\/ES.svg',
          parent: {
            id: 73,
            name: 'Spain',
            area: 'Europe',
            place_id: 'ChIJi7xhMnjjQgwR7KNoB5Qs7KY',
            slug: 'spain-europe',
            parent_id: 4,
            type: 'country',
            img: '\/flags\/ES.svg',
            location: {
              type: 'Point',
              coordinates: [-3.74922, 40.463667],
            },
            viewport_north_east: {
              type: 'Point',
              coordinates: [5.098, 45.244],
            },
            viewport_south_west: { type: 'Point', coordinates: [-12.524, 35.173] },
            created_at: '2022-03-29T08:01:51.000000Z',
            updated_at: '2022-03-29T08:01:51.000000Z',
            database: true,
            image: '\/img\/flags\/ES.svg',
          },
        },
        multi_destination: [],
        multi_destination_pre: [
          {
            id: 254,
            name: 'Barcelona',
            area: 'Catalonia, Spain',
            place_id: 'ChIJ5TCOcRaYpBIRCmZHTz37sEQ',
            slug: 'barcelona-catalonia-spain',
            parent_id: 73,
            type: 'destination',
            img: null,
            location: {
              type: 'Point',
              coordinates: [41.3873974, 2.168568],
            },
            viewport_north_east: {
              type: 'Point',
              coordinates: [41.468297427243, 2.2280449242179],
            },
            viewport_south_west: {
              type: 'Point', coordinates: [41.317038489254, 2.0523332629526],
            },
            created_at: '2022-03-29T08:37:26.000000Z',
            updated_at: '2022-03-29T08:37:26.000000Z',
            database: true,
            image: '\/img\/flags\/ES.svg',
            parent: {
              id: 73,
              name: 'Spain',
              area: 'Europe',
              place_id: 'ChIJi7xhMnjjQgwR7KNoB5Qs7KY',
              slug: 'spain-europe',
              parent_id: 4,
              type: 'country',
              img: '\/flags\/ES.svg',
              location: {
                type: 'Point',
                coordinates: [-3.74922, 40.463667],
              },
              viewport_north_east: {
                type: 'Point',
                coordinates: [5.098, 45.244],
              },
              viewport_south_west: { type: 'Point', coordinates: [-12.524, 35.173] },
              created_at: '2022-03-29T08:01:51.000000Z',
              updated_at: '2022-03-29T08:01:51.000000Z',
              database: true,
              image: '\/img\/flags\/ES.svg',
            },
          },
          {
            id: 147, name: 'Madagascar', area: 'Africa', place_id: 'ChIJRYUj6uOk0SERiBN7l8HjRFI', slug: 'madagascar-africa', parent_id: 1, type: 'country', img: '\/flags\/MG.svg', location: { type: 'Point', coordinates: [46.869107, -18.766947] }, viewport_north_east: { type: 'Point', coordinates: [50.9985001, -11.4369999] }, viewport_south_west: { type: 'Point', coordinates: [42.7368, -26.2146] }, created_at: '2022-03-29T08:02:33.000000Z', updated_at: '2022-03-29T08:02:33.000000Z', database: true, image: '\/img\/flags\/MG.svg',
          },
        ],
        currency: null,
        currency_pre: {
          id: 'NOK', name: 'Norwegian krone', symbol: 'kr', flag: null, image: '\/img\/flags\/placeholder.png',
        },
        multi_currency: [],
        multi_currency_pre: [{
          id: 'DKK', name: 'Danish krone', symbol: 'Kr', flag: null, image: '\/img\/flags\/placeholder.png',
        }, {
          id: 'NOK', name: 'Norwegian krone', symbol: 'kr', flag: null, image: '\/img\/flags\/placeholder.png',
        }],
        guide: null,
        guide_pre: {
          id: 1,
          user_id: 1,
          team_id: 1,
          created_at: '2022-05-23T14:29:54.000000Z',
          updated_at: '2022-05-23T14:29:54.000000Z',
          email: 'jorgen@ellera.no',
          tour_types: 'manicure, parks, puzzles, hiking',
          knowledge: 'Eos quod voluptatibus dolor provident.',
          experience: 'Ut nostrum numquam ut dolorum quia. Rerum neque sed a est quia odit aut alias. Officiis ab eius omnis reprehenderit quas fugiat.',
          user: {
            id: 1,
            name: 'J\u00f8rgen Ellingsen',
            email: 'jorgen@ellera.no',
            email_verified_at: '2022-01-01T00:00:00.000000Z',
            current_team_id: 1,
            profile_photo_path: null,
            created_at: null,
            updated_at: '2022-05-23T14:29:53.000000Z',
            profile_photo_url: 'https:\/\/ui-avatars.com\/api\/?name=J+E&color=7F9CF5&background=EBF4FF',
            role: {
              id: 3, team_id: null, name: 'owner', guard_name: 'web', created_at: '2022-05-23T14:29:16.000000Z', updated_at: '2022-05-23T14:29:16.000000Z', pivot: { model_id: 1, role_id: 3, model_type: 'App\\Models\\User' },
            },
          },
          team: {
            id: 1,
            user_id: 1,
            name: 'Ellera',
            email: null,
            photo_path: null,
            created_at: '2022-05-23T14:29:52.000000Z',
            updated_at: '2022-05-23T14:29:52.000000Z',
            personal_team: 0,
            photo_url: 'https:\/\/ui-avatars.com\/api\/?name=Ellera&color=FFFFFF&background=25383C',
            isOperator: true,
            isGuide: true,
            operator: {
              id: 1, team_id: 1, created_at: '2022-05-23T14:29:54.000000Z', updated_at: '2022-05-23T14:29:54.000000Z',
            },
            guide: {
              id: 1, team_id: 1, created_at: '2022-05-23T14:29:54.000000Z', updated_at: '2022-05-23T14:29:54.000000Z',
            },
          },
        },
        multi_guide: [],
        multi_guide_pre: [{
          id: 1,
          user_id: 1,
          team_id: 1,
          created_at: '2022-05-23T14:29:54.000000Z',
          updated_at: '2022-05-23T14:29:54.000000Z',
          email: 'jorgen@ellera.no',
          tour_types: 'manicure, parks, puzzles, hiking',
          knowledge: 'Eos quod voluptatibus dolor provident.',
          experience: 'Ut nostrum numquam ut dolorum quia. Rerum neque sed a est quia odit aut alias. Officiis ab eius omnis reprehenderit quas fugiat.',
          user: {
            id: 1,
            name: 'J\u00f8rgen Ellingsen',
            email: 'jorgen@ellera.no',
            email_verified_at: '2022-01-01T00:00:00.000000Z',
            current_team_id: 1,
            profile_photo_path: null,
            created_at: null,
            updated_at: '2022-05-23T14:29:53.000000Z',
            profile_photo_url: 'https:\/\/ui-avatars.com\/api\/?name=J+E&color=7F9CF5&background=EBF4FF',
            role: {
              id: 3, team_id: null, name: 'owner', guard_name: 'web', created_at: '2022-05-23T14:29:16.000000Z', updated_at: '2022-05-23T14:29:16.000000Z', pivot: { model_id: 1, role_id: 3, model_type: 'App\\Models\\User' },
            },
          },
          team: {
            id: 1,
            user_id: 1,
            name: 'Ellera',
            email: null,
            photo_path: null,
            created_at: '2022-05-23T14:29:52.000000Z',
            updated_at: '2022-05-23T14:29:52.000000Z',
            personal_team: 0,
            photo_url: 'https:\/\/ui-avatars.com\/api\/?name=Ellera&color=FFFFFF&background=25383C',
            isOperator: true,
            isGuide: true,
            operator: {
              id: 1, team_id: 1, created_at: '2022-05-23T14:29:54.000000Z', updated_at: '2022-05-23T14:29:54.000000Z',
            },
            guide: {
              id: 1, team_id: 1, created_at: '2022-05-23T14:29:54.000000Z', updated_at: '2022-05-23T14:29:54.000000Z',
            },
          },
        }, {
          id: 2,
          user_id: 2,
          team_id: 1,
          created_at: '2022-05-23T14:29:54.000000Z',
          updated_at: '2022-05-23T14:29:54.000000Z',
          email: 'simen@ellera.no',
          tour_types: 'crosswords, hiking, library',
          knowledge: 'Veritatis esse est quibusdam.',
          experience: 'Consequatur ipsum et unde aspernatur modi. Animi magnam est eos eveniet nulla eos. Sint similique est dolor neque et. Nesciunt aliquid ipsam et atque qui numquam.',
          user: {
            id: 2,
            name: 'Simen Eira',
            email: 'simen@ellera.no',
            email_verified_at: '2022-01-01T00:00:00.000000Z',
            current_team_id: 1,
            profile_photo_path: null,
            created_at: null,
            updated_at: '2022-05-23T14:29:53.000000Z',
            profile_photo_url: 'https:\/\/ui-avatars.com\/api\/?name=S+E&color=7F9CF5&background=EBF4FF',
            role: {
              id: 4, team_id: null, name: 'manager', guard_name: 'web', created_at: '2022-05-23T14:29:27.000000Z', updated_at: '2022-05-23T14:29:27.000000Z', pivot: { model_id: 2, role_id: 4, model_type: 'App\\Models\\User' },
            },
          },
          team: {
            id: 1,
            user_id: 1,
            name: 'Ellera',
            email: null,
            photo_path: null,
            created_at: '2022-05-23T14:29:52.000000Z',
            updated_at: '2022-05-23T14:29:52.000000Z',
            personal_team: 0,
            photo_url: 'https:\/\/ui-avatars.com\/api\/?name=Ellera&color=FFFFFF&background=25383C',
            isOperator: true,
            isGuide: true,
            operator: {
              id: 1, team_id: 1, created_at: '2022-05-23T14:29:54.000000Z', updated_at: '2022-05-23T14:29:54.000000Z',
            },
            guide: {
              id: 1, team_id: 1, created_at: '2022-05-23T14:29:54.000000Z', updated_at: '2022-05-23T14:29:54.000000Z',
            },
          },
        }, {
          id: 3,
          user_id: 3,
          team_id: 1,
          created_at: '2022-05-23T14:29:55.000000Z',
          updated_at: '2022-05-23T14:29:55.000000Z',
          email: 'mehrnaz@ellera.no',
          tour_types: 'exploring, watch the sunset',
          knowledge: 'Et quasi dolorum libero.',
          experience: 'Sed quidem hic non voluptatem dolor aperiam. Inventore quasi adipisci eos similique est. Saepe tempora modi rerum voluptatem aut ducimus. Et veniam sed fugiat unde.',
          user: {
            id: 3,
            name: 'Mehrnaz Asadi',
            email: 'mehrnaz@ellera.no',
            email_verified_at: '2022-01-01T00:00:00.000000Z',
            current_team_id: 1,
            profile_photo_path: null,
            created_at: null,
            updated_at: '2022-05-23T14:29:54.000000Z',
            profile_photo_url: 'https:\/\/ui-avatars.com\/api\/?name=M+A&color=7F9CF5&background=EBF4FF',
            role: {
              id: 4, team_id: null, name: 'manager', guard_name: 'web', created_at: '2022-05-23T14:29:27.000000Z', updated_at: '2022-05-23T14:29:27.000000Z', pivot: { model_id: 3, role_id: 4, model_type: 'App\\Models\\User' },
            },
          },
          team: {
            id: 1,
            user_id: 1,
            name: 'Ellera',
            email: null,
            photo_path: null,
            created_at: '2022-05-23T14:29:52.000000Z',
            updated_at: '2022-05-23T14:29:52.000000Z',
            personal_team: 0,
            photo_url: 'https:\/\/ui-avatars.com\/api\/?name=Ellera&color=FFFFFF&background=25383C',
            isOperator: true,
            isGuide: true,
            operator: {
              id: 1, team_id: 1, created_at: '2022-05-23T14:29:54.000000Z', updated_at: '2022-05-23T14:29:54.000000Z',
            },
            guide: {
              id: 1, team_id: 1, created_at: '2022-05-23T14:29:54.000000Z', updated_at: '2022-05-23T14:29:54.000000Z',
            },
          },
        }, {
          id: 4,
          user_id: 4,
          team_id: 1,
          created_at: '2022-05-23T14:29:55.000000Z',
          updated_at: '2022-05-23T14:29:55.000000Z',
          email: 'pererik@ellera.no',
          tour_types: 'pedicure, museums, exploring',
          knowledge: 'Eius ut quis et quia aliquid quae.',
          experience: 'Et laudantium officia beatae provident. Numquam porro beatae tempora laborum. Veritatis vel velit odio totam fugiat. In ea quos assumenda reprehenderit.',
          user: {
            id: 4,
            name: 'Per Erik Kattai-Eira',
            email: 'pererik@ellera.no',
            email_verified_at: '2022-01-01T00:00:00.000000Z',
            current_team_id: 1,
            profile_photo_path: null,
            created_at: null,
            updated_at: '2022-05-23T14:29:54.000000Z',
            profile_photo_url: 'https:\/\/ui-avatars.com\/api\/?name=P+E+K&color=7F9CF5&background=EBF4FF',
            role: {
              id: 4, team_id: null, name: 'manager', guard_name: 'web', created_at: '2022-05-23T14:29:27.000000Z', updated_at: '2022-05-23T14:29:27.000000Z', pivot: { model_id: 4, role_id: 4, model_type: 'App\\Models\\User' },
            },
          },
          team: {
            id: 1,
            user_id: 1,
            name: 'Ellera',
            email: null,
            photo_path: null,
            created_at: '2022-05-23T14:29:52.000000Z',
            updated_at: '2022-05-23T14:29:52.000000Z',
            personal_team: 0,
            photo_url: 'https:\/\/ui-avatars.com\/api\/?name=Ellera&color=FFFFFF&background=25383C',
            isOperator: true,
            isGuide: true,
            operator: {
              id: 1, team_id: 1, created_at: '2022-05-23T14:29:54.000000Z', updated_at: '2022-05-23T14:29:54.000000Z',
            },
            guide: {
              id: 1, team_id: 1, created_at: '2022-05-23T14:29:54.000000Z', updated_at: '2022-05-23T14:29:54.000000Z',
            },
          },
        }, {
          id: 5,
          user_id: 5,
          team_id: 1,
          created_at: '2022-05-23T14:29:55.000000Z',
          updated_at: '2022-05-23T14:29:55.000000Z',
          email: 'tiril@ellera.no',
          tour_types: 'library, parks, coloring, flea market',
          knowledge: 'Et et neque culpa.',
          experience: 'Aut saepe assumenda excepturi nihil optio sequi. Et et est aspernatur. Sint in id earum ullam.',
          user: {
            id: 5,
            name: 'Tiril Fjell',
            email: 'tiril@ellera.no',
            email_verified_at: '2022-01-01T00:00:00.000000Z',
            current_team_id: 1,
            profile_photo_path: null,
            created_at: null,
            updated_at: '2022-05-23T14:29:54.000000Z',
            profile_photo_url: 'https:\/\/ui-avatars.com\/api\/?name=T+F&color=7F9CF5&background=EBF4FF',
            role: {
              id: 4, team_id: null, name: 'manager', guard_name: 'web', created_at: '2022-05-23T14:29:27.000000Z', updated_at: '2022-05-23T14:29:27.000000Z', pivot: { model_id: 5, role_id: 4, model_type: 'App\\Models\\User' },
            },
          },
          team: {
            id: 1,
            user_id: 1,
            name: 'Ellera',
            email: null,
            photo_path: null,
            created_at: '2022-05-23T14:29:52.000000Z',
            updated_at: '2022-05-23T14:29:52.000000Z',
            personal_team: 0,
            photo_url: 'https:\/\/ui-avatars.com\/api\/?name=Ellera&color=FFFFFF&background=25383C',
            isOperator: true,
            isGuide: true,
            operator: {
              id: 1, team_id: 1, created_at: '2022-05-23T14:29:54.000000Z', updated_at: '2022-05-23T14:29:54.000000Z',
            },
            guide: {
              id: 1, team_id: 1, created_at: '2022-05-23T14:29:54.000000Z', updated_at: '2022-05-23T14:29:54.000000Z',
            },
          },
        }],
      }),
    };
  },
};
</script>
